import { useState } from "react";
import { matchPath, useLocation } from "react-router-dom";
import {
  Button,
  Link,
  List,
  ListItem,
  Collapse,
  Typography,
} from "@mui/material";
import { BCPAngleUp, BCPAngleDown } from "../components/icons/bcp/BCPIcons";
import makeStyles from "@mui/styles/makeStyles";
import { findGetParameter } from "../components/utilities/UtilityFunctions";
import { isBrand } from "./environmentVariables";
const IS_PRIMAL = isBrand("primal");

const useStyles = makeStyles((theme) => ({
  listItem: {
    display: "flex",
    paddingBottom: 0,
  },
  button: {
    color: theme?.palette?.text?.secondary,
    fontWeight: "500",
    justifyContent: "flex-start",
    letterSpacing: 0,
    padding: `10px ${theme?.spacing ? theme.spacing(1) : null}`,
    textTransform: "none",
    "& svg": {
      marginRight: theme?.spacing ? theme.spacing(1) : null,
      "& path": {
        fill: theme?.palette?.text?.secondary,
      },
    },
  },
  childButton: {
    color: theme?.palette?.text?.secondary,
    fontWeight: "500",
    justifyContent: "flex-start",
    letterSpacing: 0,
    padding: `10px ${theme?.spacing ? theme.spacing(1) : null}`,
    textTransform: "none",
    "& svg": {
      marginRight: theme?.spacing ? theme.spacing(1) : null,
      "& path": {
        fill: theme?.palette?.text?.secondary,
      },
    },

    marginLeft: theme?.spacing ? theme.spacing(2) : null,

    fontSize: "0.8rem",
    "&:hover": {
      color: theme?.palette?.primary?.main,
      filter: `drop-shadow(0 0 ${theme?.spacing ? theme.spacing(2) : null} ${
        theme?.palette?.primary?.main
      })`,
      textDecoration: "none",
    },
  },
  buttonActive: {
    color: theme?.palette?.primary?.main,
  },
  divider: {
    marginTop: theme?.spacing ? theme.spacing(1) : null,
    marginBottom: theme?.spacing ? theme.spacing(1) : null,
  },
}));

const NavItem = (props) => {
  const {
    onClick,
    href,
    icon: Icon,
    iconSize,
    title,
    target,
    children,
    nested,
    ...rest
  } = props;

  const location = useLocation();
  const classes = useStyles();
  const activeTabParam = findGetParameter("active_tab");
  var [isOpen, setIsOpen] = useState(false);
  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const active =
    !IS_PRIMAL &&
    ((href === "/" && location.pathname === href) ||
      (href &&
        href !== "/" &&
        activeTabParam &&
        href.includes(location.search)) ||
      (href &&
        href !== "/" &&
        !activeTabParam &&
        matchPath(
          {
            path: href,
            end: false,
          },
          location.pathname
        )))
      ? { color: "link.main" }
      : {};

  if (children) {
    return (
      <>
        <ListItem
          disableGutters
          className={classes.listItem}
          onClick={handleClick}
        >
          <Button
            fullWidth
            component={Link}
            color="drawer"
            variant="contained"
            href={href || null}
            sx={{
              ...active,
              pr: 2,
              pl: 2,
              borderRadius: 0,
              transition: "unset",
              boxShadow: "unset",
              backgroundColor: "inherit",
              fontWeight: "500",
              justifyContent: "flex-start",
              letterSpacing: 0,
              textTransform: "none",
              "& svg": {
                marginRight: 2,
              },
            }}
          >
            {Icon && (
              <Icon
                size="24"
                sx={{
                  fontSize: iconSize ? `${iconSize}px` : "22px",
                  width: iconSize ? `${iconSize}px` : "22px",
                  ...active,
                }}
              />
            )}
            <span>{title}</span>
          </Button>
          {isOpen ? (
            <BCPAngleUp
              style={{
                width: "20px",
                "font-size": "20px",
                "margin-right": "8px",
              }}
            />
          ) : (
            <BCPAngleDown
              style={{
                width: "20px",
                "font-size": "20px",
                "margin-right": "8px",
              }}
            />
          )}
        </ListItem>
        <Collapse in={isOpen} timeout="auto" unmountOnExit sx={{ ml: 2 }}>
          <List component="Box" disablePadding>
            {children.map((child) => (
              <NavItem nested {...child} />
            ))}
          </List>
        </Collapse>
      </>
    );
  } else {
    return (
      <ListItem disableGutters className={classes.listItem} {...rest}>
        {Boolean(href || onClick) ? (
          <Button
            fullWidth
            component={href ? Link : null}
            color="drawer"
            variant="contained"
            href={href || null}
            target={target || null}
            onClick={onClick || null}
            sx={{
              ...active,
              pr: 2,
              pl: 2,
              borderRadius: 0,
              transition: "unset",
              boxShadow: "unset",
              backgroundColor: "inherit",
              fontWeight: "500",
              justifyContent: "flex-start",
              letterSpacing: 0,
              textTransform: "none",
              "& svg": {
                marginRight: 2,
              },
            }}
          >
            {Icon && (
              <Icon
                size="24"
                sx={{
                  fontSize: iconSize ? `${iconSize}px` : "22px",
                  width: iconSize ? `${iconSize}px` : "22px",
                  ...active,
                }}
              />
            )}
            <span>{title}</span>
          </Button>
        ) : (
          <Typography sx={{ pr: 2, pl: 2, width: "100%" }}>
            {Icon && (
              <Icon
                size="24"
                sx={{
                  fontSize: iconSize ? `${iconSize}px` : "22px",
                  width: iconSize ? `${iconSize}px` : "22px",
                  ...active,
                }}
              />
            )}
            <span
              style={{
                maxWidth: Icon ? "calc(100% - 24px)" : "100%",
                display: "block",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {title}
            </span>
          </Typography>
        )}
      </ListItem>
    );
  }
};

export default NavItem;
